import { ChartData } from '@crm/api'
import { getColor } from '@crm/components/Charts/utils'
import { ChartDataItem } from '@crm/features/reports/types'
import { Text } from '@shared/components'
import { Card, Empty, Flex } from 'antd'
import {
  Bar,
  BarChart as RCBarchart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

type Props = {
  label?: string
  isLoading?: boolean
  data?: ChartData
  xAxy?: string
}

export const BarChart = ({ data, label, isLoading, xAxy }: Props) => {
  const dataMapping = data?.data as ChartDataItem[]

  return (
    <Card title={label} loading={isLoading}>
      {data ? (
        <div className="w-full" style={{ height: 360 }}>
          <ResponsiveContainer width="100%" height="100%">
            <RCBarchart data={dataMapping}>
              <defs>
                {data?.mapping?.map((_, index) => (
                  <linearGradient
                    key={index}
                    id={`colorLine${index}`}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor={getColor(index + 4)}
                      stopOpacity={0.8}
                    />
                    <stop
                      offset="95%"
                      stopColor={getColor(index + 4)}
                      stopOpacity={0.4}
                    />
                  </linearGradient>
                ))}
              </defs>

              <Tooltip
                content={({ active, payload }) =>
                  active && payload ? (
                    <Flex vertical gap={4}>
                      <Text>{payload[0].payload.name}</Text>
                      {data?.mapping?.map((item, index) => (
                        <p key={index}>
                          {item.label}:{' '}
                          {payload[0].payload[item?.field_name || '']}
                        </p>
                      ))}
                    </Flex>
                  ) : null
                }
              />
              {data?.mapping?.map((item, index) => (
                <Bar
                  key={index}
                  dataKey={item?.field_name || 'value'}
                  fill={`url(#colorLine${index})`}
                />
              ))}
              <XAxis dataKey={xAxy} />
              <YAxis />
            </RCBarchart>
          </ResponsiveContainer>
        </div>
      ) : (
        <Empty />
      )}
    </Card>
  )
}
